import { createFileRoute } from "@tanstack/react-router";

import { SystemConfigPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/system")({
  component: SystemConfigPage,
});
